import { CloseOutlined } from "@ant-design/icons";
import { Button, Checkbox, Select } from "antd";
import { useState, useEffect } from "react";
import { productVids } from "../../extensions/helper";

const SettingsFilter = ({ items = [], value, activePage, onClose }) => {
  const emptyFilter = { searchText: '' };
  const [tempFilter, setTempFilter] = useState(value ?? emptyFilter);

  useEffect(() => {
    setTempFilter(value ?? emptyFilter);
  }, [value]);

  const displayFiltersForPage = (activePage) => {
    if (activePage === "products") {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <Select options={productVids} value={tempFilter.vid ?? null} allowClear placeholder="Вид"
            style={{ width: '100%' }} onChange={val => setTempFilter(prev => ({ ...prev, vid: val ?? null }))}/>
          <Checkbox checked={tempFilter.showHidden ?? false} onChange={e => setTempFilter(prev => ({ ...prev, showHidden: e.target.checked }))}> Показывать неактивные </Checkbox> 
        </div>
      );
    }
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
          <div className="sport-modal-title">
            <span>Фильтр</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} style={{ zIndex: 9 }} />
          </div>
          <div className="payments-mobile-filter-container">
            {displayFiltersForPage(activePage)}
            <Button onClick={() => onClose(tempFilter)}>ОК</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsFilter;
